// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DemandApprovalPage {

    .DemandElement {
        width: 100%;
        /* box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274); */
        border-radius: 5px;
        padding: 20px 50px;
        background-color: white;

        label {
            font-size: 16px;
            font-weight: 500;
        }


        .elements {
            margin: 15px 0px;

            .part1 {
                font-size: 14px;
                border: 1px solid black;
            }


            .labelContianer {
                width: fit-content;

                label {
                    font-size: 14px;
                }
            }
        }


        textarea,
        select,
        input {
            width: 100%;
            border: 1px solid #505050;
            padding: 5px 10px;
            font-size: 16px;
            font-weight: 400;
            border-radius: 3px;
        }

        select {
            font-size: 14px !important;
            font-weight: 500 !important;
            color: #817f7f;
        }

        select:focus {
            color: black;
        }

        textarea {
            height: 12vh;
        }

        ::placeholder {
            color: #817f7f;
        }
    }

    .shadowbox {
        box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274);
        border-radius: 5px;
        padding: 25px 15px;
        background-color: white;
    }



    .tableContainer {
        width: 100%;

        table {
            width: 100%;
            border: 1px solid #000000;


            tr,
            th,
            td {
                padding: 10px;
            }

            tr,
            th,
            td {
                border: 1px solid #000000 !important;
                font-size: 16px;

            }

            thead {
                tr {
                    background-color: #0094DE;
                    color: white;

                    th {
                        font-weight: 500 !important;
                    }
                }
            }

            tbody {
                tr {
                    /* border: 1px solid #000000 !important; */

                    td {
                        /* border: 1px solid #000000 !important; */
                        font-weight: 400 !important;
                    }

                }
            }

        }
    }

    .tableContainer1 {
        width: 100%;

        table {
            width: 100%;
            border: 1px solid #000000;


            tr,
            th,
            td {
                padding: 10px 0px;
            }

            tr,
            th,
            td {
                border: 1px solid #000000 !important;
                font-size: 10px;

            }

            thead {
                tr {
                    background-color: #0094DE;
                    color: white;

                    th {
                        font-weight: 500 !important;
                    }
                }
            }

            tbody {
                tr {
                    /* border: 1px solid #000000 !important; */

                    td {
                        /* border: 1px solid #000000 !important; */
                        font-weight: 400 !important;
                    }

                }
            }

        }
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/DemandManagement/DemandApproval/DemandApproval.css"],"names":[],"mappings":"AAAA;;IAEI;QACI,WAAW;QACX,sDAAsD;QACtD,kBAAkB;QAClB,kBAAkB;QAClB,uBAAuB;;QAEvB;YACI,eAAe;YACf,gBAAgB;QACpB;;;QAGA;YACI,gBAAgB;;YAEhB;gBACI,eAAe;gBACf,uBAAuB;YAC3B;;;YAGA;gBACI,kBAAkB;;gBAElB;oBACI,eAAe;gBACnB;YACJ;QACJ;;;QAGA;;;YAGI,WAAW;YACX,yBAAyB;YACzB,iBAAiB;YACjB,eAAe;YACf,gBAAgB;YAChB,kBAAkB;QACtB;;QAEA;YACI,0BAA0B;YAC1B,2BAA2B;YAC3B,cAAc;QAClB;;QAEA;YACI,YAAY;QAChB;;QAEA;YACI,YAAY;QAChB;;QAEA;YACI,cAAc;QAClB;IACJ;;IAEA;QACI,gDAAgD;QAChD,kBAAkB;QAClB,kBAAkB;QAClB,uBAAuB;IAC3B;;;;IAIA;QACI,WAAW;;QAEX;YACI,WAAW;YACX,yBAAyB;;;YAGzB;;;gBAGI,aAAa;YACjB;;YAEA;;;gBAGI,oCAAoC;gBACpC,eAAe;;YAEnB;;YAEA;gBACI;oBACI,yBAAyB;oBACzB,YAAY;;oBAEZ;wBACI,2BAA2B;oBAC/B;gBACJ;YACJ;;YAEA;gBACI;oBACI,0CAA0C;;oBAE1C;wBACI,0CAA0C;wBAC1C,2BAA2B;oBAC/B;;gBAEJ;YACJ;;QAEJ;IACJ;;IAEA;QACI,WAAW;;QAEX;YACI,WAAW;YACX,yBAAyB;;;YAGzB;;;gBAGI,iBAAiB;YACrB;;YAEA;;;gBAGI,oCAAoC;gBACpC,eAAe;;YAEnB;;YAEA;gBACI;oBACI,yBAAyB;oBACzB,YAAY;;oBAEZ;wBACI,2BAA2B;oBAC/B;gBACJ;YACJ;;YAEA;gBACI;oBACI,0CAA0C;;oBAE1C;wBACI,0CAA0C;wBAC1C,2BAA2B;oBAC/B;;gBAEJ;YACJ;;QAEJ;IACJ;AACJ","sourcesContent":[".DemandApprovalPage {\r\n\r\n    .DemandElement {\r\n        width: 100%;\r\n        /* box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274); */\r\n        border-radius: 5px;\r\n        padding: 20px 50px;\r\n        background-color: white;\r\n\r\n        label {\r\n            font-size: 16px;\r\n            font-weight: 500;\r\n        }\r\n\r\n\r\n        .elements {\r\n            margin: 15px 0px;\r\n\r\n            .part1 {\r\n                font-size: 14px;\r\n                border: 1px solid black;\r\n            }\r\n\r\n\r\n            .labelContianer {\r\n                width: fit-content;\r\n\r\n                label {\r\n                    font-size: 14px;\r\n                }\r\n            }\r\n        }\r\n\r\n\r\n        textarea,\r\n        select,\r\n        input {\r\n            width: 100%;\r\n            border: 1px solid #505050;\r\n            padding: 5px 10px;\r\n            font-size: 16px;\r\n            font-weight: 400;\r\n            border-radius: 3px;\r\n        }\r\n\r\n        select {\r\n            font-size: 14px !important;\r\n            font-weight: 500 !important;\r\n            color: #817f7f;\r\n        }\r\n\r\n        select:focus {\r\n            color: black;\r\n        }\r\n\r\n        textarea {\r\n            height: 12vh;\r\n        }\r\n\r\n        ::placeholder {\r\n            color: #817f7f;\r\n        }\r\n    }\r\n\r\n    .shadowbox {\r\n        box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274);\r\n        border-radius: 5px;\r\n        padding: 25px 15px;\r\n        background-color: white;\r\n    }\r\n\r\n\r\n\r\n    .tableContainer {\r\n        width: 100%;\r\n\r\n        table {\r\n            width: 100%;\r\n            border: 1px solid #000000;\r\n\r\n\r\n            tr,\r\n            th,\r\n            td {\r\n                padding: 10px;\r\n            }\r\n\r\n            tr,\r\n            th,\r\n            td {\r\n                border: 1px solid #000000 !important;\r\n                font-size: 16px;\r\n\r\n            }\r\n\r\n            thead {\r\n                tr {\r\n                    background-color: #0094DE;\r\n                    color: white;\r\n\r\n                    th {\r\n                        font-weight: 500 !important;\r\n                    }\r\n                }\r\n            }\r\n\r\n            tbody {\r\n                tr {\r\n                    /* border: 1px solid #000000 !important; */\r\n\r\n                    td {\r\n                        /* border: 1px solid #000000 !important; */\r\n                        font-weight: 400 !important;\r\n                    }\r\n\r\n                }\r\n            }\r\n\r\n        }\r\n    }\r\n\r\n    .tableContainer1 {\r\n        width: 100%;\r\n\r\n        table {\r\n            width: 100%;\r\n            border: 1px solid #000000;\r\n\r\n\r\n            tr,\r\n            th,\r\n            td {\r\n                padding: 10px 0px;\r\n            }\r\n\r\n            tr,\r\n            th,\r\n            td {\r\n                border: 1px solid #000000 !important;\r\n                font-size: 10px;\r\n\r\n            }\r\n\r\n            thead {\r\n                tr {\r\n                    background-color: #0094DE;\r\n                    color: white;\r\n\r\n                    th {\r\n                        font-weight: 500 !important;\r\n                    }\r\n                }\r\n            }\r\n\r\n            tbody {\r\n                tr {\r\n                    /* border: 1px solid #000000 !important; */\r\n\r\n                    td {\r\n                        /* border: 1px solid #000000 !important; */\r\n                        font-weight: 400 !important;\r\n                    }\r\n\r\n                }\r\n            }\r\n\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
